import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from '../../shared/services/auth.service';
import { BatteryOptimization } from '@capawesome-team/capacitor-android-battery-optimization';
import { Capacitor } from "@capacitor/core";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    if (Capacitor.getPlatform() === 'android') {
      if (this.router.url !== '/battery-optimization-required') {
        const status = await BatteryOptimization.isBatteryOptimizationEnabled();
        if (status.enabled) {
          await BatteryOptimization.requestIgnoreBatteryOptimization();
          const updatedStatus = await BatteryOptimization.isBatteryOptimizationEnabled();
          if (updatedStatus.enabled) {
            this.router.navigate(['/battery-optimization-required']);
            return false;
          }
        }
      }
    }
    return this.authService.authGuard();
  }
}